import base from '@/http/url_base';

export default {
  SESSION: base.API_COMPTE + '/formation-sessions',
  PARTICIPER: base.API_COMPTE + '/formation-sessions/participer',
  ANNULER_PARTICIPATION: base.API_COMPTE + '/formation-sessions/participation',
};
